export default __webpack_public_path__ + "static/media/element_51.b208ed78.jpg";